document.addEventListener('DOMContentLoaded', function() {
  window.personalizationCountry = {};
  window.personalizationCountryMap = {};
  const selectedCharms = [];

  let get_price_save_html;
  let price_save = document.querySelector('.so-product-price .price-save strong');
  if(price_save){
    get_price_save_html = price_save.innerHTML;
  }
  
  const atc_btn = document.querySelector('.so-btn-add-to-cart-wrap button[data-add-to-cart]');
  if(atc_btn){
    atc_btn.setAttribute('disabled','disabled');  
  }
  
  // holder product on off switch
  const on_off_holder_pro = document.querySelector('.var-bundle-line .bundle-line-inner-checkbox #holder_enable');
  if(on_off_holder_pro){
    on_off_holder_pro.addEventListener('change',function(){
      const holder_pros = this.closest('.var-bundle-line').querySelector('.select-content');
      const holder_prosradios = this.closest('.var-bundle-line').querySelectorAll('.select-content .image_radio_button_control label.radio-button-label');
      
      if(this.checked){
        if(holder_pros){
          holder_pros.classList.remove('hidden');
        }
      }else{
        
        if(holder_pros){
          holder_pros.classList.add('hidden');
          holder_prosradios.forEach(function(label){
            const radio = label.querySelector('input[type="radio"]');
            if(radio){
              radio.checked = false;
            }
          });
          
          const holder_materials = document.querySelectorAll('.var-bundle-line .select-content .image_radio_button_inner');
          if(holder_materials){
            holder_materials.forEach(function(material){
              material.classList.add('hidden');

              const firstRadio = material.querySelector('input[type="radio"]');
              if (firstRadio) {
                firstRadio.checked = true;
                firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }
              
            });
          }
          
        }
        
        
      }

      //check atc
      atcenable();
    });

    //on load show
    on_off_holder_pro.checked = true;
    on_off_holder_pro.dispatchEvent(new Event('change', { bubbles: true }));
  }

  //holder products radio
  const holder_prosradios = document.querySelectorAll('.var-bundle-line .select-content .image_radio_button_control label.radio-button-label');
  if(holder_prosradios){
    holder_prosradios.forEach(function(label){
      const radio = label.querySelector('input[type="radio"]');
      if(radio){
        radio.addEventListener('change',function(){
          const this_pro_id = label.getAttribute('data-pro-id');

          const holder_materials = document.querySelectorAll('.var-bundle-line .select-content .image_radio_button_inner');
          if(holder_materials){
            holder_materials.forEach(function(material){
              material.classList.add('hidden');
            });
          }
          
          const holder_match_material = document.querySelector('.var-bundle-line .select-content .image_radio_button_inner[data-pro-id="'+this_pro_id+'"]');
          if(holder_match_material){
            holder_match_material.classList.remove('hidden');

            const firstRadio = holder_match_material.querySelector('input[type="radio"]');
            if (firstRadio) {
              firstRadio.checked = true;
              firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

         //check atc
         atcenable();
        //  set_prices();
          
        });
      }
    });
  }

  //holder products material change
  const holder_materials = document.querySelectorAll('.var-bundle-line .select-content .image_radio_button_inner');
  if(holder_materials){
    holder_materials.forEach(function(material){
      const all_radio = material.querySelectorAll('input[type="radio"]');
      if(all_radio){
        all_radio.forEach(function(radio){
          radio.addEventListener('change',function(){
            const material_val = this.getAttribute('data-val');
            if(material_val){
              material.querySelector('.var-title').textContent = material_val;
            }

            const newImageSrc = this.getAttribute('data-img');
            const countryType = this.closest('.charm-option')?.getAttribute('data-type') || 'holder';
            const imgAlt = material_val;
            // Remove previous image (all radio siblings)
            holder_materials.forEach(function(material){
              const all_radio = material.querySelectorAll('input[type="radio"]');
              all_radio.forEach((siblingRadio) => {
                const siblingImg = siblingRadio.getAttribute('data-img');
                if (siblingImg && siblingImg !== newImageSrc) {
                  // removeCharmImageFromSlider(siblingImg);
                }
              });
            });

            //all options image remove
            const allOptions = document.querySelectorAll('.charm-option');
    
            allOptions.forEach(option => {
                // Remove both silver and gold images
                ['data-src-silver', 'data-src-gold'].forEach(dataAttr => {
                  const imgSrc = option.getAttribute(dataAttr);
                  // if (imgSrc) removeCharmImageFromSlider(imgSrc);
                });
            });
            
            // Add new image to slider
            if (newImageSrc) {
              const $mainSlider_id = $('.so-featured-carousel-main').attr('id');
              const $thumbSlider_id = $('.so-thumbnail-carousel-thumb').attr('id');
              const $mainSlider = $('#' + $mainSlider_id);
              const $thumbSlider = $('#' + $thumbSlider_id);

              // Check if image already exists
              const existingMainImg = $mainSlider.find(`.slide_charm_img`);
              const existingThumbImg = $thumbSlider.find(`.slide_charm_img`);

              if (existingMainImg.length > 0 && existingThumbImg.length > 0) {
                existingMainImg.attr('src', newImageSrc).attr('alt', imgAlt);
                existingThumbImg.attr('src', newImageSrc).attr('alt', imgAlt);

                const $mainSlide = existingMainImg.closest('.so_slick-slide');
                const $thumbSlide = existingThumbImg.closest('.so_slick-slide');
              
                if (!$mainSlide.hasClass('so_slick-current')) {
                  const index = $mainSlide.data('slick-index');
                  $mainSlider.so_slick('slickGoTo', index);
                }
              
                if (!$thumbSlide.hasClass('so_slick-current')) {
                  const thumbIndex = $thumbSlide.data('slick-index');
                  $thumbSlider.so_slick('slickGoTo', thumbIndex);
                }
              }else{
  
              const newMainSlide = `
                <div class="">
                  <img class="so-carousel-img so-carousel-featured slide_charm_img holder" data-val="${countryType}" alt="${imgAlt}"
                       src="${newImageSrc}"
                       style="max-width: 100%; max-height: 100%; height: auto; width: auto; object-fit: contain; display: block; margin: auto;" />
                </div>`;
  
              const newThumbSlide = `
                <div class="">
                  <img class="so-carousel-img so-carousel-lazy-load slide_charm_img holder" data-val="${countryType}" alt="${imgAlt}"
                       src="${newImageSrc}"
                       style="max-width: 100%; max-height: 100%; height: auto; width: auto; object-fit: contain; display: block; margin: auto;" />
                </div>`;
              
  
              // setTimeout(() => {
                window.shineon.carousels.destroy();
                $('.so-thumbnail-carousel-thumb').append(newThumbSlide);
                $('.so-featured-carousel-main').append(newMainSlide);
                window.shineon.carousels.init();
                // After re-init, go to the last slide
                setTimeout(function() {
                  var $featured = $('.so-featured-carousel-main');
                  if ($featured.length && $featured.hasClass('so_slick-initialized')) {
                    var lastIndex = $featured.find('.slick-slide').not('.slick-cloned').length - 1;
                    $featured.so_slick('slickGoTo', lastIndex);
                  }
                }, 300); // small delay to ensure init is complete


                // if ($mainSlider.hasClass('so_slick-initialized')) {
                //   // $mainSlider.so_slick('slickAdd', newMainSlide, 0, true);
                //   // $mainSlider.so_slick('slickGoTo', 0);
                //   $mainSlider.so_slick('slickAdd', newMainSlide, false);
                //   $mainSlider.so_slick('setPosition');
                //   var mainLastIndex = $mainSlider.so_slick('getSlick').slideCount - 1;
                //   $mainSlider.so_slick('slickGoTo', mainLastIndex);
      
                //   // $mainSlider.so_slick('setPosition');
                // }
                // if ($thumbSlider.hasClass('so_slick-initialized')) {
                //   // $thumbSlider.so_slick('slickAdd', newThumbSlide, 0, true);
                //   // $thumbSlider.so_slick('slickGoTo', 0);
                //   // $thumbSlider.so_slick('setPosition');
                //   $thumbSlider.so_slick('slickAdd', newThumbSlide, false);
                //   $thumbSlider.so_slick('setPosition');
                //   var thumbLastIndex = $thumbSlider.so_slick('getSlick').slideCount - 1;
                //   $thumbSlider.so_slick('slickGoTo', thumbLastIndex);
                // }
              }
              // }, 50);
            }
            //End add new image to slider
            
            
            set_prices();
          });
        });
      }
    });
  }


  // show/hide Maps and Flags
  const flag_map_tab = document.querySelectorAll('.var-bundle-line.country-bundle .image_radio_button_control .radio-button-label');
  const flag_options = document.querySelector('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .flag-options');
  const map_options = document.querySelector('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .map-options');
  
  if(flag_map_tab){
    flag_map_tab.forEach(function(tab_label){
      tab_label.querySelector('input[type="radio"]').addEventListener('change',function(){
        const tab_val = this.value;
        // console.log('tab_val',tab_val);

        if(tab_val.includes('map')){
          flag_options.classList.add('hidden');
          map_options.classList.remove('hidden');
        }else if(tab_val.includes('flag')){
          flag_options.classList.remove('hidden');
          map_options.classList.add('hidden');
        }
        
      });
    });
  }

  //charm products material change
  const charm_materials = document.querySelector('.var-bundle-line.country-bundle .image_radio_button_inner');
  if(charm_materials){
      const selected_radio = charm_materials.querySelector('input[type="radio"]:checked');
      const sel_material_val = selected_radio.value;
      console.log('sel_material_val',sel_material_val);
      const charm_options = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option');
      const sel_down_val = sel_material_val.toLowerCase();
       if(charm_options){
        charm_options.forEach(function(option){
          if(sel_down_val.includes('silber') && option.classList.contains('data-silver-sold')){
            option.classList.add('out-of-stock');
            option.classList.add('hidden');
            option.querySelector('.vtdrop--low-quantity').classList.remove('hidden');
            option.querySelector('.vtdrop--quantity').classList.add('hidden');

            if(option.querySelector('.vtdrop-inline').classList.contains('active')){
              charm_remove(option);
            }
          }else if(sel_down_val.includes('gold') && option.classList.contains('data-gold-sold')){
            option.classList.add('out-of-stock');
            option.classList.add('hidden');
            option.querySelector('.vtdrop--low-quantity').classList.remove('hidden');
            option.querySelector('.vtdrop--quantity').classList.add('hidden');
            if(option.querySelector('.vtdrop-inline').classList.contains('active')){
              charm_remove(option);
            }
          }else{
            option.classList.remove('out-of-stock');
            option.classList.remove('hidden');
            option.querySelector('.vtdrop--low-quantity').classList.add('hidden');
            option.querySelector('.vtdrop--quantity').classList.remove('hidden');
          }
        });
       }

      const all_radio = charm_materials.querySelectorAll('input[type="radio"]');
      if(all_radio){
        all_radio.forEach(function(radio){
          radio.addEventListener('change',function(){
            const material_val = this.value;
            if(material_val){
              charm_materials.querySelector('.var-title').textContent = material_val;
            }

            const down_val = material_val.toLowerCase();
            const charm_options = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option');
            if(charm_options){
              charm_options.forEach(function(option){
                if(down_val.includes('silber') && option.classList.contains('data-silver-sold')){
                  option.classList.add('out-of-stock');
                  option.classList.add('hidden');
                  option.querySelector('.vtdrop--low-quantity').classList.remove('hidden');
                  option.querySelector('.vtdrop--quantity').classList.add('hidden');

                  if(option.querySelector('.vtdrop-inline').classList.contains('active')){
                    charm_remove(option);
                  }
                }else if(down_val.includes('gold') && option.classList.contains('data-gold-sold')){
                  option.classList.add('out-of-stock');
                  option.classList.add('hidden');
                  option.querySelector('.vtdrop--low-quantity').classList.remove('hidden');
                  option.querySelector('.vtdrop--quantity').classList.add('hidden');
                  if(option.querySelector('.vtdrop-inline').classList.contains('active')){
                    charm_remove(option);
                  }
                }else{
                  option.classList.remove('out-of-stock');
                  option.classList.remove('hidden');
                  option.querySelector('.vtdrop--low-quantity').classList.add('hidden');
                  option.querySelector('.vtdrop--quantity').classList.remove('hidden');
                }
              });
            }
            
          });
        });
      }
  }


  //search functionality
  const searchInput = document.querySelector(".var-bundle-line.country-bundle .vt-multi_selector .multiselector_search input");
  const clearBtn = document.getElementById("clear-search");
  const charmOptions = document.querySelectorAll(".var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option");

  function filterOptions() {
    const query = searchInput.value.trim().toLowerCase();

    // Show or hide clear button
    clearBtn.style.display = query.length > 0 ? "inline-block" : "none";

    charmOptions.forEach(option => {
      const type = option.dataset.type.toLowerCase();
      if (query.length > 1 && !type.includes(query)) {
        option.classList.add("hidden");
      } else {
        option.classList.remove("hidden");
      }
    });
  }

  function clearSearch() {
    searchInput.value = "";
    clearBtn.style.display = "none";

    charmOptions.forEach(option => {
      option.classList.remove("hidden");
    });
  }

  searchInput.addEventListener("input", filterOptions);
  clearBtn.addEventListener("click", clearSearch);
  //End search functionality


  //charm options plus/minus click
  const charm_options = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option');
  if(charm_options){
    charm_options.forEach(function(option){
      const showQuantityBtn = option.querySelector('.show--quantity');
      if(showQuantityBtn){
        showQuantityBtn.addEventListener('click',function(event){
          event.preventDefault();
          event.target.closest(".vtdrop-inline").classList.add("active");
          this.classList.add("hidden");
          const quantityBox = this.closest(".vtdrop--quantity").querySelector(".quantity-box");
          quantityBox.classList.remove("hidden");

          //update image function
          update_image_slider(option);
          update_charm_select_html(option);

          //check atc
          atcenable();
          set_prices();
          
        });
      }

      //qty buttons click
      const qtyAdjustBtns = option.querySelectorAll('.qty-adjust');
  
      qtyAdjustBtns.forEach(btn => {
        btn.addEventListener('click', function(event) {
          event.preventDefault();
  
          const isPlus = btn.classList.contains("qty-adjust--plus");
          const qtyInput = option.querySelector('.quantity-box input[type="text"]');
          if (!qtyInput) return;
  
          let currentVal = parseInt(qtyInput.value || "1", 10);
  
          // console.log('currentVal',currentVal)
          if (isPlus) {
            currentVal++;
          } else {
            // console.log('currentVal',currentVal)
            if (currentVal <= 1) {
              // UI reset
              const vtdrop = option.querySelector(".vtdrop-inline");
              const showQuantity = option.querySelector(".show--quantity");
              const quantityBox = option.querySelector(".quantity-box");
  
              vtdrop?.classList.remove("active");
              showQuantity?.classList.remove("hidden");
              quantityBox?.classList.add("hidden");
  
              // Remove from charm HTML
              const charmName = option.querySelector(".charm-name")?.textContent;
              const charmType = vtdrop?.getAttribute("data-meta-type") || "flag";
              const charmId = `${charmName}_${charmType}`;
              document.querySelector(`.multiselector--value .charm-item[data-charm-id="${charmId}"]`)?.remove();

              const deletepersonalize = option.querySelector('.vtdrop-inline-edit.active');
              if(deletepersonalize){
                const delete_btn = deletepersonalize.querySelector('.delete-backnote');
                if(delete_btn){
                  delete_btn.click();
                }
              }
  
              // Remove image only if it matches this charm
              update_image_slider(option, true);
  
              // Update charm count
              // update_charm_select_html(document.createElement('div'));
              //check atc
              setTimeout(() => {
                update_charm_select_html(option);
                const charmName = option.querySelector(".charm-name")?.textContent;
                const charmType = vtdrop?.getAttribute("data-meta-type") || "flag";
                const charmId = `${charmName}_${charmType}`;
                document.querySelector(`.multiselector--value .charm-item[data-charm-id="${charmId}"]`)?.remove();
              }, 300);
              
              atcenable();
              set_prices();
              
              return;
            } else {
              currentVal--;
            }
          }
  
          qtyInput.value = currentVal;
  
          // Always update image & charm selection for any change
         if (isPlus) {
          update_image_slider(option); // Add or re-add image
         }
         
          update_charm_select_html(option); // Update charm UI
          //check atc
          atcenable();
          set_prices();
        });
      });

      //personalization btn
      const personalize_btn = option.querySelector('.vtdrop-modalcta-flag');
      if(personalize_btn){
        personalize_btn.addEventListener('click',function(event){
          event.preventDefault();
          const $this = this;
          personalizeCharmModalOpen($this);
        });
      }
      //end personalization btn
      
      
      
    });
  }
  //end charm options plus/minus click
  


  //on charm personalizatio input
  document.querySelectorAll(".personalize_input").forEach(input => {
      input.addEventListener("input", e => {
          updateFrontFlagInputPrev()
      })
  })

  //on second line add in personalization button
  document.querySelector(".flag-back-input button").addEventListener("click", function() {
      const hiddenInputs = document.querySelectorAll(".flag-back-input input.hidden"),
          charmType = document.querySelector(".var-bundle-line.country-bundle .image_radio_button_control input[type='radio']:checked").value.toLowerCase();
      hiddenInputs.length > 0 && (hiddenInputs[0].classList.remove("hidden"), hiddenInputs[0].type = "text");
      let remainingInputs = document.querySelectorAll(".flag-back-input input.hidden").length;
      if (charmType === "map" && (remainingInputs = 0), remainingInputs === 1) {
          const buttonSpan = document.querySelector(".flag-back-input button > span");
          buttonSpan && (buttonSpan.textContent = "Dritte Zeile hinzufügen")
      } else if (remainingInputs === 0) {
          const button2 = document.querySelector(".flag-back-input button");
          button2 && (button2.style.display = "none")
      }
  })

  //on submit personalization
  document.querySelector(".cflag-button").addEventListener("click", () => {
      const activeSpan = document.querySelector(".var-bundle-line.country-bundle .image_radio_button_control input[type='radio']:checked"),
          charmType = activeSpan ? activeSpan.value.toLowerCase() : "",
          countryGet = standardizeCountryName(document.querySelector(".flag-front-info h4").textContent.replaceAll(" ", "-").toLowerCase());
      let countryPerStr = "";
      charmType === "flag" ? (window.personalizationCountry[countryGet] = [], document.querySelectorAll(".flag-back-input input").forEach(input => {
          input.value && (window.personalizationCountry[countryGet].push({
              input_value: input.value
          }), countryPerStr += `<span>${input.value}</span>;`)
      })) : (window.personalizationCountryMap[countryGet] = [], document.querySelectorAll(".flag-back-input input").forEach(input => {
          input.value && (window.personalizationCountryMap[countryGet].push({
              input_value: input.value
          }), countryPerStr += `<span>${input.value}</span>;`)
      }));
      let finalBackStr = "";
      if (countryPerStr) {
          if (finalBackStr = "<strong>Back:</strong> " + countryPerStr, charmType === "flag") {
              const targetElement = document.querySelector(`.charm-option[data-type="${countryGet}"]`);
              if (targetElement) {
                  const charmFlagText = targetElement.querySelector(".charm_flag_text"),
                      flagInlineEdit = targetElement.querySelector(".flag-inline-edit"),
                      backNotes = targetElement.querySelector(".flag-inline-edit .back-notes");
                  charmFlagText && (charmFlagText.style.display = "none"), flagInlineEdit && (flagInlineEdit.style.display = "block", flagInlineEdit.classList.add("active")), backNotes && (backNotes.innerHTML = finalBackStr)
              }
          }
      } else {
          const inlineEdit = document.querySelector(`.vtdrop-inline-edit[data-type='${countryGet}']`);
          inlineEdit && (inlineEdit.style.display = "none", inlineEdit.classList.remove("active"));
          const button2 = document.querySelector(`button.vtdrop-modalcta-flag[data-type='${countryGet}']`);
          button2 && (button2.style.display = "block")
      }
      const closeButton = document.querySelector(".country-flag-modal .cfmodal-close");
      closeButton && closeButton.click()

      set_prices();
  })
  //end on submit personalization

  //on edit/delete charm note click
  document.addEventListener("click", e => {
      let personaliseEdit = e.target.closest(".edit-backnote"),
          personaliseDelete = e.target.closest(".delete-backnote");
  
      if (personaliseEdit) {
          e.preventDefault();
          editCharm(personaliseEdit);
          return;
      }
  
      if (personaliseDelete) {
          e.preventDefault();
          removePersonalizeCharm(personaliseDelete);
          return;
      }
  });
  //End on edit/delete charm note click

  
  //charm personalization
  function personalizeCharmModalOpen(button){
    let selectedCharmFlag;
    const charm_material = document.querySelector('.var-bundle-line.country-bundle .image_radio_button_inner input[type="radio"]:checked').value.toLowerCase();
    charm_material === "silber" ? selectedCharmFlag = "https://cdn.shopify.com/s/files/1/0602/0795/6165/files/silver-back.png?v=1751547695" : charm_material === "gold" && (selectedCharmFlag = "https://cdn.shopify.com/s/files/1/0602/0795/6165/files/gold-back.png?v=1751547699");

    //back image
    const previewImage = document.querySelector(".country-flag-modal .front-flag-inputprev_dev .flag-kitchen-chain");
    previewImage && selectedCharmFlag && (previewImage.src = selectedCharmFlag);

    //flag image
    const actualCharmImage = document.querySelector(".front-flag-preview-add .flag-kitchen-chain");
    if (actualCharmImage) {
        const dataAttr = charm_material.includes('silber') ? 'data-silver-image' : 'data-gold-image';
        const selectedCharmFlag2 = button.getAttribute(dataAttr);
        actualCharmImage.src = selectedCharmFlag2
    }

    //country text
    const charmFlagText = document.querySelector(".flag-info-item.flag-front-info h4");
    charmFlagText && (charmFlagText.textContent = button.getAttribute("data-flag-text"));
    fillPersonlizeCountryData(button.getAttribute("data-type"));

    const modal = document.querySelector(".country-flag-modal"),overlay = document.querySelector(".overlay-modal");
    modal && overlay && (modal.classList.add("js-modal-open"), overlay.style.display = "block")
    
  }

  //edit personalization open
  function editCharm(element) {
      const selectedCharmTitle = element.getAttribute("data-title-type"),
          selectedCharmflag = document.querySelector(`.vtdrop-inline[data-type="${selectedCharmTitle}"] img`).getAttribute("data-src"),
          flagTitleElement = document.querySelector(".flag-front-info > h4");
      flagTitleElement && (flagTitleElement.textContent = selectedCharmTitle);
      const flagPreview = document.querySelector(".front-flag-preview-add .flag-kitchen-chain");
      flagPreview && flagPreview.setAttribute("src", selectedCharmflag);
    
      fillPersonlizeCountryData(selectedCharmTitle);
    
      const modal = document.querySelector(".country-flag-modal");
      modal && modal.classList.add("js-modal-open"), document.querySelectorAll(".flag-front .front-chain").forEach(chain => {
          chain.style.display = "none"
      });
      // const activeFrontChain = document.querySelector(`.flag-front .${colorMaterial}`);
      // activeFrontChain && (activeFrontChain.style.display = "block"), document.querySelectorAll(".flag-black .front-chain").forEach(chain => {
      //     chain.style.display = "none"
      // });
      // const activeBlackChain = document.querySelector(`.flag-black .${colorMaterial}`);
      // activeBlackChain && (activeBlackChain.style.display = "block");
      const overlay = document.querySelector(".overlay-modal");
      overlay && (overlay.style.display = "block")
  }
  //End edit personalization open

  //delete personalization
  function removePersonalizeCharm(element) {
    const button = element,
        countryGet = button.getAttribute("data-type"),
        activeSpan = document.querySelector(".var-bundle-line.country-bundle .image_radio_button_control input[type='radio']:checked"),
        charmType = activeSpan ? activeSpan.value.toLowerCase() : "",
        parent = button.closest(".charm-option");
    if (charmType === "flag") {
        const targetElement = document.querySelector(`.charm-option[data-type="${countryGet}"]`);
        if (targetElement) {
            const flagInlineEdit = targetElement.querySelector(".flag-inline-edit"),
                backNotes = targetElement.querySelector(".flag-inline-edit .back-notes");
            if (flagInlineEdit && (flagInlineEdit.style.display = "none", flagInlineEdit.classList.remove("active")), backNotes && (backNotes.innerHTML = ""), parent) {
                const personalizeButton = parent.querySelector(".vtdrop-modalcta-flag");
                personalizeButton && (personalizeButton.style.display = "")
            }
        }
    }
    window.personalizationCountry[countryGet] = [], window.personalizationCountryMap[countryGet] = []

    set_prices();
}
  //End delete personalization

  function fillPersonlizeCountryData(selectedCharmCountry) {
        const countryFlagName = standardizeCountryName(selectedCharmCountry),
            activeSpan = document.querySelector(".var-bundle-line.country-bundle .image_radio_button_control input[type='radio']:checked"),
            charmType = activeSpan ? activeSpan.value.toLowerCase() : "",
            inputs = document.querySelectorAll(".flag-back-input input"),
            buttonSpan = document.querySelector(".flag-back-input button > span"),
            button = document.querySelector(".flag-back-input button"),
            // personalizationData = charmType === "flag" ? this.personalizationCountry[countryFlagName] : this.personalizationCountryMap[countryFlagName];
           personalizationData = charmType === "flag" ? window.personalizationCountry[countryFlagName] : window.personalizationCountryMap[countryFlagName];
        personalizationData && personalizationData.length > 0 ? (personalizationData.forEach((item, index) => {
            inputs[index] && (inputs[index].classList.remove("hidden"), inputs[index].value = item.input_value)
        }), charmType === "flags" ? personalizationData.length === 2 ? buttonSpan && (buttonSpan.textContent = "Dritte Zeile hinzufügen") : personalizationData.length === 3 && button && (button.style.display = "none") : personalizationData.length === 1 ? buttonSpan && (buttonSpan.textContent = "Zweite Zeile hinzufügen") : personalizationData.length === 2 && button && (button.style.display = "none")) : inputs.forEach((input, index) => {
            input.value = "", index > 0 && input.classList.add("hidden"), buttonSpan.textContent = "Zweite Zeile hinzufügen", button.style.display = "block"
        });

    //update personalize texts
     updateFrontFlagInputPrev();
    }

  function standardizeCountryName(countryName){return countryName.toLowerCase().replace(/[^a-z0-9\s-]/g,"").replace(/\s+/g,"-").replace(/-+/g,"-")}

  function updateFrontFlagInputPrev() {
        const allInputValues = [],
            activeSpan = document.querySelector(".var-bundle-line.country-bundle .image_radio_button_control input[type='radio']:checked"),
            charmType = activeSpan ? activeSpan.value.toLowerCase() : "",
            previewElement = document.querySelector(".front-flag-inputprev-text");
        charmType === "flag" ? (previewElement && (previewElement.style.display = "block"), document.querySelectorAll(".flag-back-input input:not(.hidden)").forEach(input => {
            input.value && allInputValues.push(input.value)
        }), previewElement && (previewElement.innerHTML = allInputValues.join("<br>"))) : previewElement && (previewElement.style.display = "none")
    }

  //modal close
  document.querySelector(".cfmodal-close")?.addEventListener("click", () => {
    const modal = document.querySelector(".country-flag-modal"),
        overlay = document.querySelector(".overlay-modal");
    modal && overlay && (modal.classList.remove("js-modal-open"), modal.classList.remove("map-personalize"), overlay.style.display = "none")
  });
  //End charm personalization


  //update image with charm
  function update_image_slider(option, isRemove = false) {
    const $mainSlider_id = $('.so-featured-carousel-main').attr('id');
    const $thumbSlider_id = $('.so-thumbnail-carousel-thumb').attr('id');
  
    const $mainSlider = $('#' + $mainSlider_id);
    const $thumbSlider = $('#' + $thumbSlider_id);
  
    if (!$mainSlider.length || typeof $mainSlider.slick !== 'function') return;
  
    const charm_materials = document.querySelector('.var-bundle-line.country-bundle .image_radio_button_inner');
    if (!charm_materials) return;
  
    const selectedRadio = charm_materials.querySelector('input[type="radio"]:checked');
    if (!selectedRadio) return;
  
    const material_val = selectedRadio.value.toLowerCase();
    const dataAttr = material_val.includes('silber') ? 'data-src-silver' : 'data-src-gold';
    const dataAttr_img = material_val.includes('silber') ? 'silver' : 'gold';
    const newImageSrc = option.getAttribute(dataAttr);
    const newImagecountry = option.getAttribute('data-type');
    if (!newImageSrc) return;

  
    if (isRemove) {
      // Remove only matching images (not all)
      $mainSlider.find('.slide_charm_img').each(function () {
        if ($(this).attr('src') === newImageSrc) {
          const index = $(this).closest('.so_slick-slide').data('slick-index');
          if (index !== undefined) $mainSlider.so_slick('slickRemove', index);
        }
      });
      $thumbSlider.find('.slide_charm_img').each(function () {
        if ($(this).attr('src') === newImageSrc) {
          const index = $(this).closest('.so_slick-slide').data('slick-index');
          if (index !== undefined) $thumbSlider.so_slick('slickRemove', index);
        }
      });
      return; // exit early since it's a removal
    }

    // Check if image already exists
    const existingMainImg = $mainSlider.find(`.slide_charm_img`);
    const existingThumbImg = $thumbSlider.find(`.slide_charm_img`);

    if (existingMainImg.length > 0 && existingThumbImg.length > 0) {
      existingMainImg.attr('src', newImageSrc).attr('alt', dataAttr_img);
      existingThumbImg.attr('src', newImageSrc).attr('alt', dataAttr_img);

      const $mainSlide = existingMainImg.closest('.so_slick-slide');
      const $thumbSlide = existingThumbImg.closest('.so_slick-slide');
    
      if (!$mainSlide.hasClass('so_slick-current')) {
        const index = $mainSlide.data('slick-index');
        $mainSlider.so_slick('slickGoTo', index);
      }
    
      if (!$thumbSlide.hasClass('so_slick-current')) {
        const thumbIndex = $thumbSlide.data('slick-index');
        $thumbSlider.so_slick('slickGoTo', thumbIndex);
      }
      
    }else{
  
    const newMainSlide = `
      <div class="">
        <img class="so-carousel-img so-carousel-featured slide_charm_img" data-val="${newImagecountry}" alt="${dataAttr_img}"
             src="${newImageSrc}"
             style="max-width: 100%; max-height: 100%; height: auto; width: auto; object-fit: contain; display: block; margin: auto;" />
      </div>`;
  
    const newThumbSlide = `
      <div class="">
        <img class="so-carousel-img so-carousel-lazy-load slide_charm_img" data-val="${newImagecountry}" alt="${dataAttr_img}"
             src="${newImageSrc}"
             style="height: auto; width: 100%;" />
      </div>`;

// style="max-width: 100%; max-height: 100%; height: auto; width: auto; object-fit: contain; display: block; margin: auto;"
      
  
    // Remove all charm images before adding new one
    $mainSlider.find('.slide_charm_img').each(function (i) {
      const index = $(this).closest('.so_slick-slide').data('slick-index');
      if (index !== undefined) $mainSlider.so_slick('slickRemove', index);
    });
  
    $thumbSlider.find('.slide_charm_img').each(function (i) {
      const index = $(this).closest('.so_slick-slide').data('slick-index');
      if (index !== undefined) $thumbSlider.so_slick('slickRemove', index);
    });


    // Add new slides
    setTimeout(() => {
      window.shineon.carousels.destroy();
      $('.so-thumbnail-carousel-thumb').append(newThumbSlide);
      $('.so-featured-carousel-main').append(newMainSlide);
      window.shineon.carousels.init();
      // After re-init, go to the last slide
      setTimeout(function() {
        var $featured = $('.so-featured-carousel-main');
        if ($featured.length && $featured.hasClass('so_slick-initialized')) {
          var lastIndex = $featured.find('.slick-slide').not('.slick-cloned').length - 1;
          $featured.so_slick('slickGoTo', lastIndex);
        }
      }, 300); // small delay to ensure init is complete

      if ($mainSlider.hasClass('so_slick-initialized')) {
        // $mainSlider.so_slick('slickAdd', newMainSlide, false);
        // // $mainSlider.so_slick('slickAdd', newMainSlide, 0, true);
        // // $mainSlider.so_slick('slickGoTo', 0);
        // $mainSlider.so_slick('setPosition');
        // var mainLastIndex = $mainSlider.so_slick('getSlick').slideCount - 1;
        // $mainSlider.so_slick('slickGoTo', mainLastIndex);
      }
      if ($thumbSlider.hasClass('so_slick-initialized')) {
        // $thumbSlider.so_slick('slickAdd', newThumbSlide, false);
        // // $mainSlider.so_slick('slickAdd', newThumbSlide, 0, true);
        // // $thumbSlider.so_slick('slickGoTo', 0);
        // $thumbSlider.so_slick('setPosition');
        // var thumbLastIndex = $thumbSlider.so_slick('getSlick').slideCount - 1;
        // $thumbSlider.so_slick('slickGoTo', thumbLastIndex);
      }

    }, 50);
    }
  }

  //end update image with charm

  //update charm selected html
  function update_charm_select_html(option){
    const charmWrapper = document.querySelector('.var-bundle-line.country-bundle .vt-multi_selector .multiselector--value');
    const selectedCountLabel = charmWrapper.querySelector('.selected-count');
    const valueContainer = charmWrapper.querySelector('.msvalue_value');
  
    const activeOptions = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option .vtdrop-inline.active');
  
    // Show or hide multiselector box

    if (activeOptions.length > 0) {
      charmWrapper.style.display = 'block';
    } else {
      charmWrapper.style.display = 'none';
    }

    let total_qty = 0;
    activeOptions.forEach(function(active_op){
      const qty = parseInt(active_op.querySelector('.qty__num').value);
      total_qty = total_qty + qty;
    });
  
    // Update selected count
    // selectedCountLabel.textContent = activeOptions.length;
    selectedCountLabel.textContent = total_qty;

    
    var max_qty = 110; // full bar at 110
    var progress_width = (total_qty / max_qty) * 100;
    document.querySelector(".save-progress-fill").style.width = progress_width * 10 + "%";
    
    

    // First clear all
    document.querySelectorAll(".save-progress-item").forEach(el => {
      el.classList.remove("active");
    });

    if (total_qty < 3) {
      let first_layer = 3 - total_qty; // remaining quantity until full bar
      document.querySelector(".save-progress-header h3").textContent ="Noch " + first_layer + " Anhänger!";
    }
    else
    {
      document.querySelector(".save-progress-header h3").textContent = "Glückwunsch! 🎉";
    }

    if (total_qty >= 11) {
      document.querySelector(".save-progress-item.four")?.classList.add("active");
      document.querySelector(".save-progress-item.thi")?.classList.add("active");
      document.querySelector(".save-progress-item.sec")?.classList.add("active");
      document.querySelector(".save-progress-item.first")?.classList.add("active");
      document.querySelector(".save-progress-header p").textContent = "25% Rabatt + Gratis Anhänger-Halter freigeschaltet";
    } else if (total_qty >= 8) {
      document.querySelector(".save-progress-item.thi")?.classList.add("active");
      document.querySelector(".save-progress-item.sec")?.classList.add("active");
      document.querySelector(".save-progress-item.first")?.classList.add("active");
      document.querySelector(".save-progress-header p").textContent ="20% Rabatt + Gratis Anhänger-Halter freigeschaltet";
    } else if (total_qty >= 5) {
      document.querySelector(".save-progress-item.sec")?.classList.add("active");
      document.querySelector(".save-progress-item.first")?.classList.add("active");
      document.querySelector(".save-progress-header p").textContent ="15% Rabatt + Gratis Anhänger-Halter freigeschaltet";
    } else if (total_qty >= 3) {
      document.querySelector(".save-progress-item.first")?.classList.add("active");
      document.querySelector(".save-progress-header p").textContent = "10% Rabatt + Gratis Anhänger-Halter freigeschaltet";
    }
  
    // Info from clicked option
    // const charmId = option.getAttribute('data-charm-id');
  const charmElement = option.querySelector(".vtdrop-inline"),
      charmName = option.querySelector(".charm-name").textContent,
      charmType = charmElement.getAttribute("data-meta-type") || "flag",
      charmId = `${charmName}_${charmType}`;
    
    const imgEl = option.querySelector('img');
    const imgSrc = imgEl?.getAttribute('src') || '';
    const imgAlt = imgEl?.getAttribute('alt') || '';
    const title = imgAlt;
    const qtyInput = option.querySelector('.quantity-box input[type="text"]');
    const qty = parseInt(qtyInput?.value || '1');
  
    // Check if item already exists
    let existingItem = valueContainer.querySelector(`[data-charm-id="${charmId}"]`);
  
    if (!existingItem) {
      // Create new charm-item
      const charmItem = document.createElement('span');
      charmItem.classList.add('charm-item');
      charmItem.setAttribute('data-charm-id', charmId);
      charmItem.innerHTML = `
        <img src="${imgSrc}" alt="${imgAlt}">
        ${title}
        ${qty > 1 ? `<div class="charm-quantity">(${qty})</div>` : ''}
        <button class="vtdrop-remove" data-charm-id="${charmId}">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/>
          </svg>
        </button>
      `;
      valueContainer.appendChild(charmItem);
    } else {
      // Update existing quantity
      let qtyBox = existingItem.querySelector('.charm-quantity');
      const removeBtn = existingItem.querySelector('.vtdrop-remove');
      
      if (qty > 1) {
        if (!qtyBox) {
          qtyBox = document.createElement('div');
          qtyBox.classList.add('charm-quantity');
          // existingItem.appendChild(qtyBox);
          if (removeBtn) {
            existingItem.insertBefore(qtyBox, removeBtn);
          } else {
            existingItem.appendChild(qtyBox);
          }
        }
        qtyBox.textContent = `(${qty})`;
      } else {
        if (qtyBox) qtyBox.remove();
      }
    }
  
    // Bind remove button logic
    const removeBtns = valueContainer.querySelectorAll('.vtdrop-remove');
    removeBtns.forEach(btn => {
      btn.removeEventListener('click', handleCharmRemove); // Avoid duplicates
      btn.addEventListener('click', handleCharmRemove);
    });
  }
  //end pdate charm selected html

  //charm remove function
  function handleCharmRemove(e) {
    e.preventDefault();
  
    const btn = e.currentTarget;
    const charmId = btn.getAttribute('data-charm-id');
  
    // Loop through all options to find a match by reconstructed charmId
    const allOptions = document.querySelectorAll('.charm-option');
  
    allOptions.forEach(option => {
      const charmElement = option.querySelector(".vtdrop-inline");
      const charmName = option.querySelector(".charm-name")?.textContent;
      const charmType = charmElement?.getAttribute("data-meta-type") || "flag";
      const generatedId = `${charmName}_${charmType}`;
  
      if (generatedId === charmId) {
        // Found the matching option
        charmElement.classList.remove('active');
        const qtyBox = option.querySelector('.quantity-box');
        const showQtyBtn = option.querySelector('.show--quantity');
        const qtyInput = option.querySelector('.quantity-box input[type="text"]');
        if (qtyBox) qtyBox.classList.add('hidden');
        if (showQtyBtn) showQtyBtn.classList.remove('hidden');
        if (qtyInput) qtyInput.value = 1;

        const deletepersonalize = option.querySelector('.vtdrop-inline-edit.active');
        if(deletepersonalize){
          const delete_btn = deletepersonalize.querySelector('.delete-backnote');
          if(delete_btn){
            delete_btn.click();
          }
        }

        // Remove both silver and gold images
        ['data-src-silver', 'data-src-gold'].forEach(dataAttr => {
          const imgSrc = option.getAttribute(dataAttr);
          if (imgSrc) removeCharmImageFromSlider(imgSrc);
        });
        
      }
    });
  
    // Remove charm-item from summary list
    btn.closest('.charm-item')?.remove();


    //update count
    const charmWrapper = document.querySelector('.var-bundle-line.country-bundle .vt-multi_selector .multiselector--value');
    const selectedCountLabel = charmWrapper.querySelector('.selected-count');
    const activeOptions = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option .vtdrop-inline.active');
    let total_qty = 0;
    activeOptions.forEach(function(active_op){
      const qty = parseInt(active_op.querySelector('.qty__num').value);
      total_qty = total_qty + qty;
    });
    selectedCountLabel.textContent = total_qty;
    //update count
  
 
  
    // Refresh count
    // update_charm_select_html(document.createElement('div')); // Dummy call to refresh count
    //check atc
    atcenable();
    set_prices();
  }

   //charm remove from selected if soldout
  function charm_remove(option){
      const charmElement = option.querySelector(".vtdrop-inline");
      const charmName = option.querySelector(".charm-name")?.textContent;
      const charmType = charmElement?.getAttribute("data-meta-type") || "flag";
      const generatedId = `${charmName}_${charmType}`;


      const charmWrapper = document.querySelector('.var-bundle-line.country-bundle .vt-multi_selector .multiselector--value');
      const valueContainer = charmWrapper.querySelector('.msvalue_value');
      const existingItem = valueContainer?.querySelector(`.charm-item[data-charm-id="${generatedId}"]`);

      if(existingItem){
       const removeBtn = existingItem.querySelector('.vtdrop-remove');
       removeBtn.dispatchEvent(new Event('click', { bubbles: true }));
      }
      
  }

  //end charm remove function

  //on remove click from list
  function removeCharmImageFromSlider(imgSrc) {
    const $mainSlider_id = $('.so-featured-carousel-main').attr('id');
    const $thumbSlider_id = $('.so-thumbnail-carousel-thumb').attr('id');
  
    const $mainSlider = $('#' + $mainSlider_id);
    const $thumbSlider = $('#' + $thumbSlider_id);
  
    if (!$mainSlider.length || typeof $mainSlider.slick !== 'function') return;
  
    $mainSlider.find('.slide_charm_img').each(function () {
      if ($(this).attr('src') === imgSrc) {
        const index = $(this).closest('.so_slick-slide').data('slick-index');
        if (index !== undefined) $mainSlider.so_slick('slickRemove', index);
      }
    });
  
    $thumbSlider.find('.slide_charm_img').each(function () {
      if ($(this).attr('src') === imgSrc) {
        const index = $(this).closest('.so_slick-slide').data('slick-index');
        if (index !== undefined) $thumbSlider.so_slick('slickRemove', index);
      }
    });
  }
  //End on remove click from list

  //check active products length have or not for ATC enable/disable
  function atcenable(){
    // console.log('hii have')
     const activeOptions = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option .vtdrop-inline.active');
    
      // Show or hide multiselector box
      if (activeOptions.length > 0) {
          if(atc_btn){
            atc_btn.removeAttribute('disabled');  
          }
      } else {
      const charmWrapper = document.querySelector('.var-bundle-line.country-bundle .vt-multi_selector .multiselector--value');
      if (charmWrapper) {
        charmWrapper.style.display = 'none';
      }
        
        const holder_prosradios = document.querySelectorAll('.var-bundle-line .select-content .image_radio_button_control label.radio-button-label input[type="radio"]:checked');
        if(holder_prosradios.length > 0){
          if(atc_btn){
            atc_btn.removeAttribute('disabled');  
          }
        }else{
          if(atc_btn){
            atc_btn.setAttribute('disabled','disabled');  
          }
        }
      }
  }



  //on Add to cart charms
  // const atc_btn = document.querySelector('.so-btn-add-to-cart-wrap button[data-add-to-cart]');
  if(atc_btn){
    atc_btn.addEventListener('click',function(event){
      event.preventDefault();
      // console.log('hihihih')

      document.querySelectorAll(".charm-option").forEach(function(option){
        if(option.querySelector('.vtdrop-inline').classList.contains('active')){
          const charmElement = option.querySelector('.vtdrop-inline'),
                flagImage = charmElement.querySelector(".flag-image") || charmElement.querySelector(".map-image"),
                flagName = charmElement.querySelector(".charm-name").textContent,
                charmType = charmElement.getAttribute("data-meta-type") || "flag",
                charmId = `${flagName}_${charmType}`;

          const qtyInput = option.querySelector('.quantity-box input[type="text"]');
          // if (!qtyInput) return;
  
          let currentVal = parseInt(qtyInput.value || "1", 10);

          const baseImage = flagImage.getAttribute("data-src"),
                silverImage = flagImage.getAttribute("data-src-silver"),
                goldImage = flagImage.getAttribute("data-src-gold"),
                fallbackImage = flagImage.getAttribute("data-fallback"),
                countryName = flagImage.getAttribute("data-country-name"),
                goldProductId = charmElement.getAttribute("data-gold-product-id"),
                silverProductId = charmElement.getAttribute("data-silver-product-id"),
                charmData = {
                    id: charmId,
                    name: flagName,
                    country: countryName,
                    baseImage: baseImage || fallbackImage,
                    selectedImage: getMetalImage(baseImage, silverImage, goldImage, fallbackImage),
                    imageData: {
                        default: baseImage,
                        silver: silverImage,
                        gold: goldImage,
                        fallback: fallbackImage
                    },
                    goldProductId,
                    silverProductId,
                    quantity: currentVal || 1
                };

            selectedCharms.push(charmData);
        }
      });

      addToCartCustom();
    });
  }

  function getMetalImage(baseImage, silverImage, goldImage, fallbackImage){
    const charm_material = document.querySelector('.var-bundle-line.country-bundle .image_radio_button_inner input[type="radio"]:checked').value.toLowerCase();
          // charm_material === "silber" ? selectedCharmFlag = "https://cdn.shopify.com/s/files/1/0602/0795/6165/files/silver-back.png?v=1751547695" : charm_material === "gold" && (selectedCharmFlag = "https://cdn.shopify.com/s/files/1/0602/0795/6165/files/gold-back.png?v=1751547699");
        switch (charm_material) {
            case "silber":
                return silverImage || baseImage || fallbackImage;
            case "gold":
                return goldImage || baseImage || fallbackImage;
            default:
                return baseImage || fallbackImage
        }
  }

  function addToCartCustom() {
    
    // console.log('window.selectedCharms',selectedCharms);
  
    // Build cart items from selected charms
    const cartItems = selectedCharms.map(charm => {
      const type = charm.id.split("_")[1]; // e.g., "flag" or "map"
      const formattedName = type === "map"
        ? `${charm.name} Karte Charme`
        : `${charm.name} Flagge Charme`;

      const charm_material = document.querySelector('.var-bundle-line.country-bundle .image_radio_button_inner input[type="radio"]:checked').value.toLowerCase();
      const productId = charm_material === "silber"
        ? charm.silverProductId
        : charm.goldProductId;
  
      const properties = {
        __img: charm.selectedImage,
        __metal: charm_material === "silber"
          ? "Silber"
          : "Gold",
        __metal_name: charm_material === "silber" ? "Silber" : "Gold",
        __name: formattedName,
        __country: charm.country,
        __charm_type: type === "map" ? "Karte" : "Flagge",
        __type: "charm_set"
      };
  
      const charmCountry = standardizeCountryName(charm.name.toLowerCase());
      const personalizationTexts = window.personalizationCountry[charmCountry];
  
      // Add engraving lines if personalization data exists and it's not a map charm
      if (personalizationTexts && personalizationTexts.length > 0 && type !== "map") {
        const timeStamp = new Date().getTime();
        properties.__group = timeStamp;
  
        personalizationTexts.forEach((text, index) => {
          properties[`Engraving Line ${index + 1}`] = text.input_value;
        });
      }
  
      return {
        id: productId,
        quantity: charm.quantity,
        properties
      };
    });
  
    // Add the charm holder product if selected
    const holder_prosradio = document.querySelector('.var-bundle-line .select-content .image_radio_button_control label.radio-button-label input[type="radio"]:checked');
    
    if (holder_prosradio) {
      const pro_id = holder_prosradio.closest('.radio-button-label').getAttribute('data-pro-id');
      const strapProductId = document.querySelector('.var-bundle-line .select-content .image_radio_button_inner[data-pro-id="'+pro_id+'"] input[type="radio"]:checked');
      // const strapProductId = document.querySelector("strap-selector");
      if(strapProductId){
        const charmId = strapProductId.value || "";
        if (charmId !== "") {
          cartItems.push({
            id: charmId,
            quantity: 1,
            properties: {
              __type: "charm_holder",
              __itemType: "product"
            }
          });
        }
      }
    }
  
    // Add personalization-only items (engraving service products)
    const personalizationItems = cartItems.filter(item =>
      item.properties.__group &&
      item.properties["Engraving Line 1"] &&
      !item.properties.gift_box
    );

    const check_personalize = document.querySelector('.var-bundle-line.country-bundle');
    if(check_personalize){
      const personalize_id = check_personalize.getAttribute('data-personalize-id') || "";
  
      if(personalize_id !== ""){
        personalizationItems.forEach(item => {
          cartItems.push({
            id: personalize_id,
            quantity: item.quantity,
            properties: {
              __type: "product",
              __itemType: "personalize",
              __group: item.properties.__group
            }
          });
        });
      }
    }

    if(selectedCharms.length >= 3){
      const extra_pro_id = document.body.getAttribute('data-three-charm-extra-pro-id') || "";
       if(extra_pro_id !== ""){
         const timeStamp = new Date().getTime();
          cartItems.push({
            id: extra_pro_id,
            quantity: 1,
            properties: {
              // __type: "product",
              // __itemType: "personalize",
              __group: timeStamp
            }
          });
       }
    }
  
    
  
    // Send all items to Shopify cart
    const addToCartPromises = [
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items: cartItems })
      }).then(response => response.json())
    ];
  
    Promise.all(addToCartPromises)
      .then(response => {
        // document.querySelector(".product-countrycharm .cd_loading_overlay_pdp").style.display = "none";
        resetAllData();
        window.location.href = '/cart?view=shineon';
        // document.querySelector(".header_cart").click(); // Open cart drawer
      })
      .catch(error => {
        console.error("Error adding to cart:", error);
        // document.querySelector(".product-countrycharm .cd_loading_overlay_pdp").style.display = "none";
        // alert("There was an error adding items to your cart. Please try again.");
      });
  }

  //resetall data
  function resetAllData() {
    // Clear selected charms and personalization data
    selectedCharms.length = 0;
    window.personalizationCountry = [];
    window.personalizationCountryMap = [];
  
    // Click all remove buttons to clear selected charms
    document.querySelectorAll(".vtdrop-remove").forEach(el => el.click());
  
    // Click all delete-backnote buttons to remove engravings
    const removeButtons = document.querySelectorAll(".delete-backnote");
    if (removeButtons) {
      removeButtons.forEach(button => button.click());
    }
  
    // Click the charm holder swatch if it exists (to reset holder state)
    const charmholder = document.querySelector('.var-bundle-line .bundle-line-inner-checkbox #holder_enable');
    // const charmholder = document.querySelector("#swatch-checkbox");
    if (charmholder) {
      charmholder.click();
    }
  }
  //resetall data

  //End on Add to cart charms


  //set prices
  function set_prices(){
     var array = [];

     if($('.vtdrop-inline.active').length > 0){
        $(".vtdrop-inline.active").each(function() {
          var qty = parseInt($(this).find('.vtdrop--quantity .quantity-box .qty__num').val());
          var total_price_qty = parseInt($(this).data('price')) * qty;
          // array.push($(this).data('price'));
          array.push(total_price_qty);

          // console.log('pppp',$(this).data('price'));

          if($(this).siblings('.vtdrop-inline-edit.active').length > 0){
            var total_price_qty_personalize = parseInt($(this).siblings('.vtdrop-inline-edit.active').data('price')) * qty;
            // array.push($(this).siblings('.vtdrop-inline-edit.active').data('price'));
            array.push(total_price_qty_personalize);
            // console.log('pppp',$(this).siblings('.vtdrop-inline-edit.active').data('price'));
          }
        });
     }

    var total = 0;
    for (var i = 0; i < array.length; i++) {
      total += array[i] << 0;
    }

    const activeOptions = document.querySelectorAll('.var-bundle-line.country-bundle .vt-multi_selector .inner-fleg .charm-option .vtdrop-inline.active');
    let total_qty = 0;
    activeOptions.forEach(function(active_op){
      const qty = parseInt(active_op.querySelector('.qty__num').value);
      total_qty = total_qty + qty;
    });

     if (total_qty >= 11){
        var percentage = 0.25;
        var percentage_amount = total * percentage;
        total = total - percentage_amount;

        if(price_save){
          price_save.innerHTML = '-25%';
        }
     }else if(total_qty >= 8){
        var percentage = 0.20;
        var percentage_amount = total * percentage;
        total = total - percentage_amount;
        if(price_save){
          price_save.innerHTML = '-20%';
        }
     }else if(total_qty >=5){
        var percentage = 0.15;
        var percentage_amount = total * percentage;
        total = total - percentage_amount;
        if(price_save){
          price_save.innerHTML = '-15%';
        }
     }else if(total_qty >=3){
        var percentage = 0.10;
        var percentage_amount = total * percentage;
        total = total - percentage_amount;
        if(price_save){
          price_save.innerHTML = '-10%';
        }
     }else{
      if(price_save && get_price_save_html){
          price_save.innerHTML = get_price_save_html;
        }
     }

     if($('.var-bundle-line .select-content .image_radio_button_control input[type="radio"]:checked').length > 0){
      // console.log('hiiii holder added')

      var holder_var_price = $('.var-bundle-line .select-content .image_radio_button_inner:not(.hidden) input[type="radio"]:checked').attr('data-price');
      console.log('holder_var_price',holder_var_price);
      // array.push(holder_var_price);
      if(holder_var_price){
        total = total + parseInt(holder_var_price);
      }
     }

    if(total == 0){
      const atc_btn_p = document.querySelector('.so-btn-add-to-cart').getAttribute('data-default-price');
      if(atc_btn_p){
        total = atc_btn_p;
      }
    }

    $('.so-price-label.money').html(theme.Shopify.formatMoney(total, theme.money_format));
    $('.so-price-label.money').attr('data-original-price',total);

     

  }

  
});